export const selectIsGameEnded = (state) => state.isGameEnded;
